module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_8017.eabf6d96.png";